export default __webpack_public_path__ + "static/media/AddIconWhite.08231ce1.svg";